import { Link } from '@backstage/core-components';
import type { RouterProps } from '@backstage/plugin-scaffolder';
import { TemplateGroupFilter } from '@backstage/plugin-scaffolder-react';

import { CLOUDOPS_INTAKE_URL } from '../util/links';

export const templateHeaderOptions: RouterProps['headerOptions'] = {
  subtitle: (
    <>
      Self Service templates in your organization. For help with cloud
      resources, submit a request via{' '}
      <Link to={CLOUDOPS_INTAKE_URL}>CloudOps Intake</Link>.
    </>
  ) as unknown as string,
};

export const templateGroups: TemplateGroupFilter[] = [
  {
    title: 'Recommended Templates',
    filter: entity => entity.metadata.tags?.includes('recommended') ?? false,
  },
];
